import * as yup from "yup";

export const emailFieldSchema = yup.object().shape({
  email: yup.string().email("請輸入正確的電郵").required("請輸入電郵"),
});
